"use client";
import { ClientSafeProvider, signIn } from "next-auth/react";
import { useRouter } from "next/navigation";
import Image from "next/image";

export type SigninButtonProps = {
  provider: ClientSafeProvider;
  waitingListUrl?: string;
  callBackUrl?: string;
  waitingList?: boolean;
} & JSX.IntrinsicElements["button"];

export function SigninButton(props: SigninButtonProps) {
  const {
    provider,
    waitingListUrl,
    callBackUrl,
    children,
    className,
    ...buttonProps
  } = props;

  const router = useRouter();

  function onClick() {
    waitingListUrl
      ? router.push(waitingListUrl)
      : signIn(provider.id, { callBackUrl });
  }

  return (
    <button
      className={"w-48 text-2xl " + className}
      onClick={onClick}
      {...buttonProps}
    >
      <Image
        className="w-full"
        alt="Log in with bankId"
        src="/images/login/bankid.svg"
        width="130"
        height="44"
      />
      {children}
    </button>
  );
}
